/** Rotate the playground demo key once it's within this margin of expiry (or past). */
export const DEMO_KEY_REFRESH_MARGIN_MS = 5 * 60 * 1000; // 5 min

/**
 * True when a held demo key is expired or about to expire — i.e. the Playground
 * should mint a fresh one before sending it, so a stale key is never used.
 *
 * - Unparseable expiry → `true` (rotate to be safe).
 * - Missing expiry → `false` (don't force a rotation every run; the 401-retry
 *   fallback covers the rare case where it lapsed without an `expiresAt`).
 */
export function demoKeyExpiringSoon(expiresAt: string | undefined, now: number = Date.now()): boolean {
  if (!expiresAt) return false;
  const ms = new Date(expiresAt).getTime();
  if (Number.isNaN(ms)) return true;
  return ms - now <= DEMO_KEY_REFRESH_MARGIN_MS;
}
